import Avatar from '@atlaskit/avatar/Avatar';
import type { AddFlagProps } from '@databases/flags-types';
import React from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { BaseMentionBuilder } from './baseMentionBuilder.ts';
import { messages } from './i18n.ts';
import { type MentionBuilder } from './types.ts';

export class MentionFlagForSingleUser
  extends BaseMentionBuilder
  implements MentionBuilder
{
  shouldShowFlag(): boolean {
    return this.usersWithAccess.length === 1;
  }
  build(): AddFlagProps & ContentTypesFlagProps {
    const { displayName, profilePicture } = this.usersWithAccess[0];
    const id = `mention-flag-for-single-user-${this.contentId}`;
    const actions = [this.buildFieldSettingsAction(id)];

    return {
      id,
      type: 'custom',
      iconString: 'avatar',
      profilePicture,
      title: this.formatMessage(
        messages['mention-notification.flag-mention-notification-title-one-user'],
        { displayName }
      ),
      description: !this.isLocked
        ? this.mentionNotificationDescription
        : this.formatMessage(
            messages[
              'mention-notification.flag-mention-notification-description-without-field-settings'
            ]
          ),
      icon: () => <Avatar src={profilePicture} label="" />,
      actions: !this.isLocked ? actions : undefined
    };
  }
}
